export default {
    PHONE: 'phone',
};
